import type { CalendarEventTypeEnum } from '@/types/generated'

export type CalendarEventTypeLabels = Record<CalendarEventTypeEnum, string>

export const calendarEventTypeLine = (
  type: CalendarEventTypeEnum,
  labels: CalendarEventTypeLabels
): string => labels[type]

export const CALENDAR_EVENT_CHIP_CLASS = 'cal-event-chip'
